"use client"

import { FC, useMemo } from "react"
import { CheckCircle, Mail, MapPin, Phone } from "lucide-react"
import { useLanguage } from "@/src/context/LanguageContext"
import { useUI } from "@/src/lib/i18n/ui"

const Contact: FC = () => {
  const { lang } = useLanguage()
  const t = useUI(lang)

  const contactInfo = useMemo(() => [
    {
      Icon: Phone,
      label: t("contactPhone"),
      value: "+38 063 664 41 32",
      href: "tel:+380636644132",
      ariaLabel: t("contactPhoneAria"),
    },
    {
      Icon: Mail,
      label: t("contactEmail"),
      value: "obelisk79011@gmail.com",
      href: "mailto:obelisk79011@gmail.com",
      ariaLabel: t("contactEmailAria"),
    },
    {
      Icon: MapPin,
      label: t("contactAddress"),
      value: "Львів, вул. І.Франка 45",
      href: "https://maps.app.goo.gl/mH3oEa8JCmG7QyQH9",
      ariaLabel: t("contactAddressAria"),
      external: true,
    },
  ], [lang])

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-2xl font-medium text-white mb-6">{t("contactInfoHeading")}</h3>
        <address className="space-y-4 not-italic font-light">
          {contactInfo.map(({ Icon, label, value, href, ariaLabel, external }) => (
            <div key={label} className="flex items-start space-x-4">
              <Icon className="w-6 h-6 text-white mt-1 flex-shrink-0" aria-hidden="true" />
              <div>
                <p className="text-white font-medium">{label}</p>
                <a
                  href={href}
                  target={external ? "_blank" : undefined}
                  rel={external ? "noopener noreferrer" : undefined}
                  className="text-gray-300 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-900 rounded-sm"
                  aria-label={ariaLabel}
                >
                  {value}
                </a>
              </div>
            </div>
          ))}
        </address>
      </div>

      <div className="bg-black/50 p-6 rounded-lg border border-gray-800">
        <h3 className="text-xl font-medium text-white mb-4">{t("contactHoursHeading")}</h3>
        <div className="space-y-2 text-gray-300 font-light">
          <p className="flex justify-between">
            <span>{t("contactHoursMon")}</span>
            <time>10:00 - 17:00</time>
          </p>
          <p className="flex justify-between">
            <span>{t("contactHoursSun")}</span>
            <span>{t("contactHoursSunVal")}</span>
          </p>
        </div>
      </div>

      <div className="bg-gray-800/50 p-6 rounded-lg border border-gray-700">
        <h3 className="text-xl font-medium text-white mb-4">{t("contactFreeHeading")}</h3>
        <p className="text-gray-300 leading-relaxed font-light">
          {t("contactFreeDesc")}
        </p>
        <div className="mt-4 flex items-center text-green-400 font-light">
          <CheckCircle className="w-5 h-5 mr-2" aria-hidden="true" />
          <span className="text-sm font-medium">{t("contactFreeTag")}</span>
        </div>
      </div>
    </div>
  )
}

export default Contact
